import { ClientEnv } from '@/env';

// Accepts US numbers as well as international numbers (e.g. Mexico) with an
// optional leading country code, in any spacing/grouping style — unlike the
// SDK's phoneRegex, which assumes a fixed US 3-3-4 grouping.
export const phoneRegex = /^\+?[\s().-]*(?:[0-9][\s().-]*){7,15}$/;

export const getNumberIdsFromString = (idString: string | undefined): number[] => {
  if (!idString) return [];

  const ids: number[] = [];
  for (const id of idString.split(',')) {
    const parsedId = parseInt(id.trim(), 10);
    if (!isNaN(parsedId)) {
      ids.push(parsedId);
    }
  }

  return ids;
};

export const isFormDynamicsLocationEnabled = (env: ClientEnv, location: string): boolean => {
  const locationMap: Record<string, boolean> = {
    'Phoenix, AZ': env.DYNAMICS_LOCATION_PHOENIX_ENABLED,
    'Mesa, AZ': env.DYNAMICS_LOCATION_MESA_ENABLED,
    'Tucson, AZ': env.DYNAMICS_LOCATION_TUCSON_ENABLED,
    'Fremont, CA': env.DYNAMICS_LOCATION_FREMONT_ENABLED,
    'West Sacramento, CA': env.DYNAMICS_LOCATION_WEST_SACRAMENTO_ENABLED,
    'San Diego, CA': env.DYNAMICS_LOCATION_SAN_DIEGO_ENABLED,
    'Orlando (Sanford), FL': env.DYNAMICS_LOCATION_ORLANDO_SANFORD_ENABLED,
    'Port St. Lucie, FL': env.DYNAMICS_LOCATION_PORT_ST_LUCIE_ENABLED,
    'Ft. Myers, FL': env.DYNAMICS_LOCATION_FT_MYERS_ENABLED,
    'Davie, FL': env.DYNAMICS_LOCATION_DAVIE_ENABLED,
    'Albuquerque, NM': env.DYNAMICS_LOCATION_ALBUQUERQUE_ENABLED,
  };

  return locationMap[location] || false;
};

export interface IFormTopicConsentValue {
  msdynmkt_purposeid: string | null;
  msdynmkt_topicid: string;
  msdynmkt_consenttypevalue: string | null;
  channels: string;
  optinwhenchecked: string;
  msdynmkt_value: string;
  labelText: string;
  msdynmkt_compliancesettings4id: string;
}

export interface IFormTopicConsent {
  DataverseFieldName: string;
  DataverseFieldValue: string;
}

export interface IGetDynamicsTopicConsentsProps {
  complianceProfileId: string;
  topicIDs: string | string[];
  channels: string;
}

export const getDynamicsTopicConsents = ({
  complianceProfileId,
  topicIDs,
  channels = 'Email,Text',
}: IGetDynamicsTopicConsentsProps): IFormTopicConsent[] => {
  const response: { DataverseFieldName: string; DataverseFieldValue: string }[] = [];

  const topicIds = Array.isArray(topicIDs)
    ? topicIDs
    : (topicIDs || '')
        .split(',')
        .map((topicId) => topicId.trim())
        .filter(Boolean);

  topicIds.forEach((topicId) => {
    response.push({
      DataverseFieldName: 'consentsubmissionvalues',
      DataverseFieldValue: JSON.stringify({
        msdynmkt_purposeid: null,
        msdynmkt_topicid: topicId,
        msdynmkt_consenttypevalue: null,
        channels,
        optinwhenchecked: 'true',
        msdynmkt_value: 'Opted In',
        labelText: 'Opted In',
        msdynmkt_compliancesettings4id: complianceProfileId,
      }),
    });
  });

  return response;
};
